<script>
import VueApexCharts from "vue-apexcharts";
import _ from "lodash";

export default {
  name: "InterfaceChart",
  components: {VueApexCharts},
  props: {
    endpoints: {
      type: Array,
      required: true
    }
  },
  computed: {
    interfaceCom: function () {
      let endpointGroupedByDomain = _.groupBy(this.endpoints, 'interface')
      return Object.keys(endpointGroupedByDomain).map(i => {
        return {
          interface: i,
          total: endpointGroupedByDomain[i].length,
        }
      })
    },
    chartSeries: function () {
      return this.interfaceCom.map(i => i.total)
    },
    chartOptions: function () {
      return {
        chart: {
          width: 900,
          type: 'pie',
        },
        labels: this.interfaceCom.map(i => i.interface)
      }
    }
  },
}
</script>

<template>
  <vx-card title="Interfaz">
    <vue-apex-charts
        v-if="chartSeries.length > 0"
        type="pie"
        id="interface-chart"
        height="800"
        :options="chartOptions"
        :series="chartSeries"
    />
  </vx-card>
</template>

<style scoped>

</style>